export const startIssueDialog = () => {
  performance.mark('open-issue-detail-start');
};

export const completeRenderIssueDialog = () => {
  try {
    performance.mark('open-issue-detail-end');
    const measure = performance.measure(
      'open-issue-detail',
      'open-issue-detail-start',
      'open-issue-detail-end'
    );

    if (measure) {
      performance.clearMarks('open-issue-detail-start');
      performance.clearMarks('open-issue-detail-end');
      performance.clearMeasures('open-issue-detail');
      return {
        time: measure.duration,
        cpuCore: navigator.hardwareConcurrency || 0,
        memory: (
          ((performance as any).memory?.usedJSHeapSize || 0) /
          1024 /
          1024
        ).toFixed(2)
      };
    }
    return null;
  } catch {
    return null;
  }
};
